// src/components/AppShell.js
import React from "react";
import Header from "./Header";

/**
 * AppShell provides the common app layout (Header + styled container).
 * Use this to wrap all pages for a consistent "inside the app" look.
 */
const AppShell = ({ children }) => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
    <Header />
    <main className="container mx-auto px-4 py-8 max-w-7xl">
      {children}
    </main>
  </div>
);

export default AppShell;
